class SizeGuide extends HTMLElement {
  toggleSwitch?: HTMLElement | null
  isUS: boolean = false

  connectedCallback() {
    this.toggleSwitch = this.querySelector(".toggle-switch")
    this.toggleSwitch?.addEventListener("click", this.toggleCmInch.bind(this))

    const bodyElement = document.querySelector("body")
    if (bodyElement) {
      // check US site
      this.isUS = bodyElement.classList.contains("is-industrie-us")
      if (this.isUS) {
        this.switchCmIn()
        this.setDefault(true)
      }
    }
  }

  setDefault(isUS:boolean) {
    const cells = this.querySelectorAll("td")
    cells.forEach((cell: HTMLElement) => {
      if (cell.dataset.originalValue) {
        if (this.toggleSwitch?.classList.contains("active")) {
          cell.innerText = isUS ? cell.dataset.originalValue : (parseFloat(cell.dataset.originalValue) / 2.54).toFixed(1)
        } else {
          cell.innerText = isUS ? (parseFloat(cell.dataset.originalValue) / 2.54).toFixed(1) : cell.dataset.originalValue
        }
      } else if (!isNaN(parseFloat(cell.innerText))) {
        cell.dataset.originalValue = cell.innerText
        if (this.toggleSwitch?.classList.contains("active")) {
          cell.innerText = isUS ? cell.dataset.originalValue : (parseFloat(cell.dataset.originalValue) / 2.54).toFixed(1)
        }
      }
    })
  }

  toggleCmInch() {
    this.toggleSwitch?.classList.toggle("active")
    this.setDefault(this.isUS)
  }

  switchCmIn() {
    var spanElements = this.toggleSwitch?.querySelectorAll('span')
    if(spanElements) {
        var temp = spanElements[0].textContent
        spanElements[0].textContent = spanElements[2].textContent
        spanElements[2].textContent = temp
    }
  }
}

customElements.define("size-guide", SizeGuide)
